import {
  List,
  Datagrid,
  TextField,
  NumberField,
  DateField,
  SearchInput,
  DateInput,
  NumberInput,
  FilterButton,
  TopToolbar,
} from 'react-admin';

const ownerFilters = [
  <SearchInput source="search" alwaysOn placeholder="Search username" />,
  <DateInput source="date_from" label="From Date" />,
  <DateInput source="date_to" label="To Date" />,
  <NumberInput source="min_volume" label="Min Volume ($)" />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
  </TopToolbar>
);

export const OwnerStatsList = () => (
  <List
    filters={ownerFilters}
    actions={<ListActions />}
    perPage={50}
    sort={{ field: 'total_volume_usd', order: 'DESC' }}
  >
    <Datagrid>
      <TextField source="user_id" label="ID" />
      <TextField source="username" />
      <TextField source="first_name" />
      <NumberField source="chats_count" label="Chats" />
      <NumberField source="total_events" label="Events" />
      <NumberField
        source="total_volume_usd"
        options={{ style: 'currency', currency: 'USD' }}
        label="Volume"
      />
      <NumberField
        source="prizes_paid_usd"
        options={{ style: 'currency', currency: 'USD' }}
        label="Prizes Paid"
      />
      <NumberField
        source="referral_earnings"
        options={{ style: 'currency', currency: 'USD' }}
        label="Referral Earnings"
      />
      <DateField source="last_activity" showTime />
    </Datagrid>
  </List>
);
